/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { LineItem } from './LineItem';
import type { MatchedBy } from './MatchedBy';
import type { OfferShort } from './OfferShort';

export type OfferLineItemMatch = {
    id: number;
    lineItem: LineItem;
    matchedOffer?: OfferShort;
    matchedBy?: MatchedBy;
    matchScore?: number;
    ocrScore: number;
    status: OfferLineItemMatch.status;
    isEditable: boolean;
    issuanceStatus?: string;
    createdAt?: string;
    collectorId?: string;
    snapId?: number;
    retailer?: string;
};

export namespace OfferLineItemMatch {

    export enum status {
        FULL_MATCH = 'FULL_MATCH',
        PARTIAL_MATCH = 'PARTIAL_MATCH',
        MANUAL_MATCH = 'MANUAL_MATCH',
    }


}

